module.exports = __webpack_public_path__ + "static/media/poppins-regular.9ed361bb.woff2";